import React from 'react';
// eslint-disable-next-line no-restricted-imports
import SVGInlineBase from 'react-svg-inline';

type SVGInlineProps = {
    svg: string;
    className?: string;
    [prop: string]: any;
};

const NON_DECORATIVE_PROPS = [
    'onClick',
    'onMouseDown',
    'onKeyDown',
    'tabIndex',
    'role',
    'aria-label',
    'aria-labelledby',
    'accessibilityLabel',
];

const SVGInline: React.FC<SVGInlineProps> = (props) => {
    const isDecorative = NON_DECORATIVE_PROPS.every((prop) => props[prop] === undefined);

    return <SVGInlineBase aria-hidden={isDecorative || undefined} {...props} />;
};

export default SVGInline;
